import React, { useState, useEffect, useRef } from "react";
import { AiOutlineVerticalRight, AiOutlineVerticalLeft } from "react-icons/ai";
import axios from "../utils/axios";
import { notifyError } from "../utils/toastError";
import MarginBottom from "./MarginBottom";


let count = 0;
let slideInterval;

const CarouselBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [banners, setBanners] = useState([]);


  const slideRef = useRef();

  const removeAnimation = () => {
    slideRef.current.classList.remove("fade-anim");
  };

  useEffect(() => {
    fetchBanners();
  },[]);

  const fetchBanners=async()=>{
    const resp= await axios.get(`api/banner/`);
    if(resp.data.success){
      // console.log(resp.data.banners);
      setBanners(resp.data.banners);
    }else{
      console.log("Error Getting banners",resp.data);
      // notifyError("Error Getting banners");
    }
  }

  useEffect(() => {
    if(banners.length>0){

    slideRef.current.addEventListener("animationend", removeAnimation);
    slideRef.current.addEventListener("mouseenter", pauseSlider);
    slideRef.current.addEventListener("mouseleave", startSlider);

    startSlider();
    
    }
    return () => {
      pauseSlider();
    };
    // eslint-disable-next-line
  }, [banners]);

  const startSlider = () => {
    slideInterval = setInterval(() => {
      handleOnNextClick();
    }, 3000);
  };

  const pauseSlider = () => {
    clearInterval(slideInterval);
  };

  const handleOnNextClick = () => {
    count = (count + 1) % banners.length;
    setCurrentIndex(count);
    slideRef.current.classList.add("fade-anim");
  };
  const handleOnPrevClick = () => {
    const productsLength = banners.length;
    count = (currentIndex + productsLength - 1) % productsLength;
    setCurrentIndex(count);
    slideRef.current.classList.add("fade-anim");
  };
  return (
    <>
    {banners.length>0?
    <>
    <h2 className="text-3xl sm:text-4xl my-10 sm:my-5 text-lyellow px-[2.3em] font-semibold text-center">
        Banner
      </h2>

      <div className="w-full flex justify-center items-center my-8">
        <div className="flex justify-center items-center w-11/12 md:w-1/2">
          <div ref={slideRef} className="w-full select-none relative">
      {banners.length>0?( 
        <div>
            <div className="aspect-w-16 aspect-h-9">
              <img src={banners[currentIndex]?.pictureLink} alt="" />
            </div>
            <div className="absolute w-full top-1/2 transform -translate-y-1/2 px-3 flex justify-between items-center">
              <button
                className="bg-black text-white p-1 rounded-full bg-opacity-50 cursor-pointer hover:bg-opacity-100 transition"
                onClick={handleOnPrevClick}
              >
                <AiOutlineVerticalRight size={30} />
              </button>
              <button
                className="bg-black text-white p-1 rounded-full bg-opacity-50 cursor-pointer hover:bg-opacity-100 transition"
                onClick={handleOnNextClick}
              >
                <AiOutlineVerticalLeft size={30} />
              </button>
            </div>
            </div>)
      :null}

          </div>
        </div>
      </div>
      
            <MarginBottom />
    
    </>
    :
    null  
  }
    </>
  );
};

export default CarouselBanner;
